import React, { MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import RoundedModal from 'components/Core/Modal/RoundedModal/RoundedModal';
import Button from 'components/Shared/Button/Button';
import Card from 'components/Shared/Card/Card';
import Contact from 'components/Shared/Icons/Contact';
import MerchantMoreInfo from 'components/Shared/Merchant/MoreInfo/MerchantMoreInfo';
import Separator from 'components/Shared/Separator/Separator';
import { modalActions } from 'store/modal/slice';
import { colors, fontSize } from 'styles/cp';

interface Props {
  companyName: string;
  companyAddress: { [key: string]: string };
  companyEmail: string;
  companyPhone: string;
  companyWebAddr: string;
  phoneNumber: string;
  show: Function;
  // eslint-disable-next-line no-unused-vars
  hide: (event: MouseEvent) => void;
}

const ContactInfoActionCard: React.FC<Props> = ({
  companyName,
  companyAddress,
  companyEmail,
  companyPhone,
  companyWebAddr,
  phoneNumber,
  show,
  hide,
}: Props) => {
  const contactClickHandler = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    show({
      component: ModalContent,
      componentProps: { closeOnClickOutSide: true, closeOnEsc: true, showCloseButton: false },
    });
  };
  const ModalContent = () => (
    <RoundedModal
      hide={hide}
      header={<FormattedMessage id="SETTINGS_CONTACT_INFO" defaultMessage="Contact info" />}
    >
      <MerchantMoreInfo
        companyAddress={companyAddress}
        companyEmail={companyEmail}
        companyPhone={companyPhone}
        companyWebAddr={companyWebAddr}
        number={phoneNumber}
      />
      <Separator height={25} />
      <Button
        aria-label="close contact details"
        onClick={hide}
        width="125px"
        data-cy="invoiceMoreDetails-contact-info-close"
      >
        <FormattedMessage id="SETTINGS_CLOSE" defaultMessage="Close" />
      </Button>
    </RoundedModal>
  );
  return (
    <Card>
      <div className="mobile-contact-info-main">
        <Contact className="contact-detail-icon" width={20} height={20} />
        <a onClick={contactClickHandler} href="#contact-info" className="contact-detail-action">
          <FormattedMessage
            id="CONTACT_COMPANY"
            defaultMessage="Contact {companyName}"
            values={{ companyName }}
          />
        </a>
      </div>

      <style jsx>{`
        .mobile-contact-info-main {
          display: flex;
          padding: 16px 43px;
          justify-content: center;
          :global(.contact-detail-icon) {
            margin-right: 10px;
          }
          .contact-detail-action {
            color: ${colors.intuit_blue};
            font-size: ${fontSize.xs};
            text-decoration: none;
          }
        }
      `}</style>
    </Card>
  );
};

export default connect(() => ({}), { show: modalActions.show, hide: modalActions.hide })(
  // @ts-ignore
  ContactInfoActionCard
);
